import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import toast from "react-hot-toast";
import ReactPaginate from "react-paginate";
import { useTranslation } from "react-i18next";
import { useRolePermission } from "../../../Hooks/useRolePermission";
import { useDispatch, useSelector } from "react-redux";
import MaterialSelect from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// component
import ButtonElement from "../../UI/Button";
import { getTableSkeletons } from "../../UI/Skeleton/Loader";
//helper
import { getLocalStorage } from "../../../Network/ApiService";
import { ls_vars } from "../../../Library/Constants";
import { pageOptions } from "../../../StaticData/UserManageMent/status";
import { scrollBar } from "../../Common/Header/ManageOutsideClickClose";
import { handleError } from "../../../Library/Utils";
//API
import {
  approveEmission,
  copyvehicleMaster,
  deleteVehicleEmission,
  getVehicleEmissionList,
  getVehicleMasterList,
  rejectEmission,
} from "../../../Network/Core/VehicleMaster/vehicleEmission";
//images
import images from "../../../Assets/images";
// css
import "../../../Assets/css/style.css";
import "../../../Assets/css/customize.css";
import "./style.css";
import { useApiCall } from "Hooks/useApiCall";
import {
  VehicleEmissionType,
  GetVehicleListParams,
} from "Network/Core/VehicleMaster/types";
import debounce from "lodash/debounce";
import VehicletEmissionModal from "Components/Common/Modal/VehicleEmissionModal/index";
import { id } from "date-fns/locale";
import DeleteConfirmationModal from "Components/Common/Modal/DeleteConfirmationModal";
import Pagination from "Components/UI/Pagination/Pagination";
import { setLoader } from "Store/Actions/Loader/LoaderActionCreator";
import MasterCopyModel from "Components/Common/Modal/CopyFromMasterModel";
import { getFilteredCommonUtils } from "Network/Core/CommonUtils/commonUtils";

const index = () => {
  const { t } = useTranslation();
  const { call } = useApiCall();
  const { checkPermission } = useRolePermission();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const site = getLocalStorage(ls_vars.PROJECT_SITE_ID);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const dateFormate = getLocalStorage(ls_vars.USER_PREFERENCES)?.dateFormat?.id;

  const isLoading = useSelector((state: any) => state.loader.loading);
  //   const search = useSelector((state: any) => state.vehicleEmission.search);

  const [orderBy, setOrderBy] = useState<string>("vehicle_type__name");
  const [statusIsASC, setStatusIsASC] = useState<boolean>(true);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageCount, setPageCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const [isVehicleEmissionModalOpen, setIsVehicleEmissionModalOpen] =
    useState<boolean>(false);
  const [isConfirmModalShow, setIsConfirmModalShow] = useState<boolean>(false);
  const [existingData, setExistingData] = useState<VehicleEmissionType>(
    {} as VehicleEmissionType
  );
  const [vehicleEmissionData, setVehicleEmissionData] = useState<
    VehicleEmissionType[]
  >([]);
  const [vehicleEmissionToBeDeleted, setVehicleEmissionToBeDeleted] =
    useState<any>();
  const [isISVehicleCopyModalOpen, setISVehicleCopyModalOpen] =
    useState<boolean>(false);
  const [isVehicleCopyModelOpen, setIsVehicleCopyModelOpen] =
    useState<boolean>(false);
  const [isGlobalMasterData, setIsGlobalMasterData] = useState<any>([]);
  const canViewVehicleEmission = checkPermission(["emissions:view"]);
  const canCreateVehicleEmission = checkPermission(["emissions:create"]);
  const canUpdateVehicleEmission = checkPermission(["emissions:update"]);
  const canDeleteVehicleEmission = checkPermission(["emissions:delete"]);
  const canApproveVehicleEmission = checkPermission(["emissions:approve"]);

  scrollBar(setIsScrolling);

  const handlePageClick = (data: { selected: number }) => {
    dispatch(setLoader(true));
    const { selected } = data;
    setPage(selected + 1);
  };

  const onChangePage = (e: { value: number }) => {
    setPerPage(e.value);
  };

  const toggleSort = (field: string, isAcs: boolean) => {
    if (field !== "id") {
      setStatusIsASC(!isAcs);
      setOrderBy(isAcs ? field : "-" + field);
    }
  };

  const handleAddVehicle = () => {
    setExistingData({} as VehicleEmissionType);
    setIsVehicleEmissionModalOpen(true);
  };
  const handleVehicleEmissionModalClose = () => {
    setIsVehicleEmissionModalOpen(false);
    fetchVehicleEmissionList();
  };
  const closeConfirmationModal = () => {
    setIsConfirmModalShow(false);
  };

  const handleEditVehicleEmission = (vehicle: VehicleEmissionType) => {
    setExistingData(vehicle);
    setIsVehicleEmissionModalOpen(true);
  };

  const fetchVehicleEmissionList = async () => {
    let params: GetVehicleListParams = {
      page: page,
      pageSize: perPage,
      orderBy: orderBy,
      search: searchValue,
      region: region,
    };
    call(
      () => getVehicleEmissionList(params, region, project.ref, site),
      (res) => {
        setVehicleEmissionData(res?.results);
        setPageCount(res?.count);
        setPageCount(Math.ceil(res?.count / perPage));
        CopyModelData();
      }
    );
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
  };

  const handleDeleteVehicleEmission = (vehicle: VehicleEmissionType) => {
    setVehicleEmissionToBeDeleted(vehicle);
    setIsConfirmModalShow(true);
    deleteEmission(vehicle);
  };

  const deleteEmission = async (vehicleEmissionToBeDeleted: any) => {
    if (vehicleEmissionToBeDeleted) {
      call(
        () =>
          deleteVehicleEmission(
            vehicleEmissionToBeDeleted.id,
            region,
            project.ref
          ),
        (res) => {
          setIsConfirmModalShow(false);
          fetchVehicleEmissionList();
        },
        { successMessage: "Translation.vehicle_emission_delete_success" }
      );
    }
  };

  useEffect(() => {
    fetchVehicleEmissionList();
  }, [page, perPage, orderBy, searchValue]);

  const handleVehicleCopyModalClose = () => {
    setIsVehicleCopyModelOpen(false);
    fetchVehicleEmissionList();
  };
  const handleCopyVehicle = () => {
    setIsVehicleCopyModelOpen(true);
  };

  const handleCopyVehicleSubmit = (selectedItems: any) => {
    const payload = {
      vehicle_emission_id: selectedItems?.map((item: any) => item.value),
      site: site,
    };
    call(
      () => copyvehicleMaster(payload, region),
      (res) => {
        setIsVehicleCopyModelOpen(false);
        fetchVehicleEmissionList();
      },
      { successMessage: "Translation.vehicle_emission_copy_success" }
    );
  };

  // const CopyModelData = () => {
  //   call(
  //     () => getVehicleMasterList(region, project.ref, site),
  //     (res) => {
  //       setIsGlobalMasterData(
  //         res.map((item: any) => ({
  //           label: `${item.vehicleTypeName}-${item.fuelTypeName}`,
  //           value: item.id,
  //         }))
  //       );
  //     }
  //   );
  // };

  const CopyModelData = () => {
    getVehicleMasterList(region, project.ref, site)
      .then((res) => {
        const vehicles = res.map((item: any) => ({
          label: `${item.vehicleTypeName}-${item.fuelTypeName}`,
          value: item.id,
        }));
        setIsGlobalMasterData(vehicles);
      })
      .catch((err) => {
        console.error("Vehicle master list fetch failed:", err);
      });
  };

  const handleApproveClick = (vehicle: VehicleEmissionType) => {
    call(
      () => approveEmission(vehicle?.id || 0, region, project.ref),
      (res) => {
        fetchVehicleEmissionList();
      },
      { successMessage: "Translation.vehicle_emission_approve_success" }
    );
  };

  const handleRejectClick = (vehicle: VehicleEmissionType) => {
    call(
      () => rejectEmission(vehicle?.id || 0, region, project.ref),
      (res) => {
        fetchVehicleEmissionList();
      },
      { successMessage: "Translation.vehicle_emission_reject_success" }
    );
  };
  return (
    <>
      {isVehicleEmissionModalOpen && (
        <>
          <VehicletEmissionModal
            handleClose={() => handleVehicleEmissionModalClose()}
            existingData={existingData}
          />
          <div className="modal-backdrop fade show" />
        </>
      )}
      {isVehicleCopyModelOpen && (
        <>
          <MasterCopyModel
            handleSubmit={handleCopyVehicleSubmit}
            handleClose={() => handleVehicleCopyModalClose()}
            data={isGlobalMasterData}
          />
        </>
      )}
      {isConfirmModalShow && (
        <DeleteConfirmationModal
          isOpen={isConfirmModalShow}
          contentName={"VehicleEmission"}
          deleteContent={"VehicleEmissionDelete"}
          closeModal={closeConfirmationModal}
          onConfirmAction={() =>
            handleDeleteVehicleEmission(vehicleEmissionToBeDeleted)
          }
        />
      )}

      <div className="page-wrapper pb-0">
        <div className="page-header">
          <h3 className="page-title">{t("Translation.vehicle_emission")}</h3>
        </div>

        <div className="page-content custom-list-div">
          <div className="user-head-sec">
            <div className="booking-list-form">
              <div className="filter-wrapper">
                <div className="f-left " style={{ gap: "10px" }}>
                  <div className="form-group form-inline filter-search ml-0">
                    <img src={images.search} />
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Translation.search")}
                      value={searchValue}
                      onChange={handleSearchChange}
                    />
                  </div>

                  {canCreateVehicleEmission && (
                    <ButtonElement
                      buttonLabel={t("Translation.vehicle_emission_add")}
                      handleClick={handleAddVehicle}
                      className="btn theme-btn invite-btn"
                    />
                  )}
                  <ButtonElement
                    buttonLabel={t("Translation.vehicle_master_copy")}
                    handleClick={handleCopyVehicle}
                    className="btn theme-btn invite-btn"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="booking-list-wrapper">
            <div
              className={`booking-list-data scroll ${
                isScrolling ? "show-scroll" : "no-scroll"
              }`}
              style={{ flex: "1 1 0%", overflow: "auto", padding: "0px 24px 24px" }}
            >
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-all"
                  role="tabpanel"
                  aria-labelledby="pills-all-tab"
                >
                  <div className="table-responsive">
                    {isLoading ? (
                      getTableSkeletons({
                        cols: 6,
                        rows: 3,
                        props: {
                          TableRowProps: {
                            style: { height: "75px" },
                          },
                        },
                      })
                    ) : (
                      <table className="display nowrap dataTable w-100">
                        <thead>
                          <tr>
                            <th
                              className="sorting sorting_asc"
                              onClick={() =>
                                toggleSort("vehicle_type__name", statusIsASC)
                              }
                            >
                              <span>{`${t("Translation.vehicle")} ${t(
                                "Translation.name"
                              )}`}</span>
                            </th>

                            <th
                              className="sorting"
                              onClick={() =>
                                toggleSort("fuel_type__name", statusIsASC)
                              }
                            >
                              <span>{t("Translation.fuel_type")}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() =>
                                toggleSort(
                                  "miles_per_gallon_or_km_per_liter",
                                  statusIsASC
                                )
                              }
                            >
                              <span>
                                {t("Translation.milesgallons_or_kmLitres")}
                              </span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() =>
                                toggleSort("emission_factor", statusIsASC)
                              }
                            >
                              <span>{t("Translation.emission_factor")}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() =>
                                toggleSort("temp_emission_factor", statusIsASC)
                              }
                            >
                              <span>
                                {t("Translation.temp_emission_factor")}
                              </span>
                            </th>
                            {(canUpdateVehicleEmission ||
                              canDeleteVehicleEmission) && (
                              <th
                                className="sorting"
                                onClick={() =>
                                  toggleSort("actions", statusIsASC)
                                }
                              >
                                {t("Translation.actions")}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {vehicleEmissionData ? (
                            vehicleEmissionData?.map((vehicle) => (
                              <tr key={vehicle.id}>
                                <td>{vehicle.vehicleTypeName}</td>
                                <td>{vehicle?.fuelTypeName}</td>
                                <td>{vehicle.milesPerGallonOrKmPerLiter}</td>
                                <td>{vehicle.emissionFactor}</td>
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <span>{vehicle.tempEmissionFactor}</span>

                                    {!vehicle.isEmissionApproved &&
                                      canApproveVehicleEmission && (
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "4px",
                                          }}
                                        >
                                          <button
                                            style={{ borderRadius: "50%" }}
                                            title={t("Translation.approve")}
                                            onClick={() =>
                                              handleApproveClick(vehicle)
                                            }
                                            type="button"
                                            className="quick-approval-action-container_checkin-button"
                                          >
                                            <img src={images.ApproveCheck} />
                                          </button>

                                          <button
                                            style={{ borderRadius: "50%" }}
                                            title={t("Translation.reject")}
                                            onClick={() =>
                                              handleRejectClick(vehicle)
                                            }
                                            type="button"
                                            className="quick-approval-action-container_refuse-button"
                                          >
                                            <img src={images.cancel_ic} />
                                          </button>
                                        </div>
                                      )}
                                  </div>
                                </td>

                                {(canUpdateVehicleEmission ||
                                  canDeleteVehicleEmission) && (
                                  <td>
                                    <div className="action-buttons">
                                      {canUpdateVehicleEmission && (
                                        <button
                                          className="btn bg-transparent border-0"
                                          onClick={() => {
                                            handleEditVehicleEmission(vehicle);
                                          }}
                                        >
                                          <img src={images.Pen} alt="edit" />
                                        </button>
                                      )}
                                      {canDeleteVehicleEmission && (
                                        <button
                                          className="btn bg-transparent border-0"
                                          onClick={() => {
                                            setVehicleEmissionToBeDeleted(
                                              vehicle
                                            );
                                            setIsConfirmModalShow(true);
                                          }}
                                        >
                                          <img
                                            src={images.DeleteRedIcon}
                                            alt="view"
                                          />
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                {t("Translation.no_vehicleEmission_found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>

                  {vehicleEmissionData?.length > 0 ? (
                    <Pagination
                      page={page}
                      onPageChange={(v) => setPage(v)}
                      perPage={perPage}
                      onPerPageChange={({ value }) => setPerPage(value)}
                      pageTotalCount={pageCount}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
